export default function calculateGroupedArea(group) {
    let area = 0;
    group.forEach((block) => (area += block.hectares));
    return Math.round(area * 100) / 100;
  }